<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:41:57
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-02-07 15:39:13
 * @FilePath: \ioc_base\src\components\common\app-nav\app-menu-tabs.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app-menu-tabs flex-between valign-center">
    <div class="tab-list-left">
      <div class="list-area" style="display: flex; flex-wrap: nowrap">
        <span
          v-if="false"
          class="tab-item el-tag el-tag--small el-tag--light"
          :class="[$route.path === $config.HOME_PAGE ? 'active' : '']"
          @click="gotoHome"
          >首页</span
        >
        <span
          v-for="item in menuTabsList"
          :key="item.path"
          :title="item.name"
          class="tab-item el-tag el-tag--light"
          :class="['tab-item', isActive(item) ? 'active' : 'hoverStyle']"
          @click="handleTabsClick(item)"
        >
          {{ item.name }}
          <i
            class="el-tag__close el-icon-close"
            v-if="menuTabsList.length > 1 ? true : false"
            @click.stop="handleClose(item)"
          ></i>
        </span>
      </div>
    </div>
    <div class="opt-right">
      <i
        v-if="isFullScreen"
        :title="$t('system.common.message.exitfullscreen')"
        :class="[$config.fontFamily, 'ioc-Fullscreen_exit', 'point-icon']"
        @click="exitFullScreen"
      ></i>
      <i
        :class="[$config.fontFamily, 'ioc-Refresh', 'point-icon']"
        title="刷新"
        @click="refreshPage"
      ></i>
      <i
        v-if="isAuth"
        :class="[$config.fontFamily, 'ioc-Error', 'point-icon']"
        title="关闭所有tab标签"
        @click="clearTabs"
      ></i>
    </div>
  </div>
</template>
<script>
import cacheKeys from "@/common/config/cacheKeys";
import eventConfig from "@src/common/config/eventConfig";
import eventBus from "@src/common/utils/eventBus";
export default {
  props: {},
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    isFullScreen() {
      return this.$store.getters.isFullScreen;
    },
    menuTabsList() {
      return this.$store.getters.menuTabsList || [];
    },
  },
  created() {
    eventBus.addListener(eventConfig.MENU_CLICK, this.addMenuFromLeftNav);
    eventBus.addListener(eventConfig.MENU_READY, this.menuReady);
  },
  watch: {
    menuTabsList(newVal, oldVal) {},
  },
  mounted() {
    this.isAuth = sessionStorage.getItem("isAuth") || true;
    // console.log(this.isAuth)
  },
  methods: {
    hasClassName(obj, name) {
      let tmpName = obj.className;
      let tmpReg = new RegExp(name, "g");
      if (tmpReg.test(tmpName)) {
        return true;
      } else {
        return false;
      }
    },
    gotoHome() {
      this.$router.push({
        path: this.$config.HOME_PAGE,
      });
    },
    //由于后台配置的是一级路由，所以前端所有的二级/三级等子路由均配置model（所属模块--即一级路由），根据一级路由判断是否高亮和删除
    isActive(menu) {
      if (
        this.$route.path === menu.path ||
        this.$route.meta.module == menu.path.split("/")[1] ||
        this.$route.meta.activePath == menu.path
      ) {
        menu.activePath = this.$route.fullPath; //该参数可以避免页签栏刷新
        return true;
      }
      // return this.$route.meta.module === menu.path
    },
    menuReady(menuMap) {
      // 菜单接口数据已拿到
      const path = this.$route.path;
      let tabList = this.menuTabsList;
      const menuObj = this.isExistFromMap(menuMap, path);
      // 当前页面路由是接口里有的
      if (typeof menuObj === "object") {
        // 当前浏览器缓存中的之前已打开的tab不存在此路由-- 添加此路由到缓存中
        if (!this.isExistByPath(tabList, path)) {
          tabList.push(menuObj);
          this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList);
        }
      }
    },
    addMenuFromLeftNav(menu) {
      console.log(menu)
      // 不存在就添加--新开是页签统一先刷新一次 防止页签关闭后数据缓存
      let tabList = this.$store.getters.menuTabsList || [];
      if (!this.isExist(tabList, menu)) {
        // this.refreshPage();
        tabList.push(menu);
        if (tabList.length > 10) {
          tabList.splice(0, 1);
        }
        this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList);
      }
    },
    isExistFromMap(menuMap, path) {
      for (let menu in menuMap) {
        if (menuMap[menu].path === path) {
          return menuMap[menu];
        }
      }
      return false;
    },
    isExistByPath(tabList, path) {
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].path === path) return true;
      }
      return false;
    },
    isExist(tabList, menu) {
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].code === menu.code || tabList[i].path === menu.path) return true;
      }
      return false;
    },
    handleClose(menu) {
      // 判断当前页面是否有缓存
      if (this.$route.meta.routerAlive == true) {
        this.$route.meta.routerAlive = false;
        this.$route.meta.routerNewAlive = true;
      }
      let index, path;
      const tabList = this.menuTabsList.slice(0);
      tabList.some((v, i) => {
        if (menu.code === v.code || menu.path === v.path) {
          index = i;
          return true;
        }
        return false;
      });
      tabList.splice(index, 1);
      this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList); // 保存删除到缓存里
      // 根据关闭的页面的module是否属于当前页面判断否跳转下个
      if (
        this.$route.path === menu.path ||
        this.$route.meta.module == menu.path.split("/")[1]
      ) {
        // 判断当前关闭的tab是否是当前打开的一级路由,
        // 是否有下一个tab index >= tabList.length 表示没有
        if (index >= tabList.length) {
          index = index - 1; // 取上一个
        }
        if (index < 0) {
          this.$router.push({
            path: this.$config.HOME_PAGE,
          });
          return;
        }
        this.$router.push(tabList[index].path);
      }
    },
    // 单个标签点击事件
    handleTabsClick(menu) {
      // console.log(menu);
      if (
        this.$route.meta.routerAlive == false &&
        this.$route.meta.routerNewAlive == true
      ) {
        this.$route.meta.routerAlive = true;
        delete this.$route.meta.routerNewAlive;
      }
      this.$router.push(menu.activePath || menu.path);
    },
    exitFullScreen() {
      this.$log.info("用户点击退出全屏");
      this.$utils.exitFullScreen();
    },
    //触发主页面刷新方法
    refreshPage() {
      this.$app.AppInstance.refresh();
    },
    // 右侧关闭按钮
    clearTabs() {
      console.log(this.menuTabsList);
      this.$confirm("是否关闭全部页签?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let otherMenu = [];
        this.menuTabsList.forEach((el) => {
          if (this.isActive(el) == true) {
            otherMenu.push(el);
          }
        });
        this.$store.commit(cacheKeys.MENU_TABS_LIST,otherMenu);
        // console.log(this.$store.getters.menuTabsList)
        // this.$router.push({
        //   path: this.$config.HOME_PAGE,
        // });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.app-menu-tabs {
  //margin-bottom: 12px;
  position: relative;
  height: 50px;
  width: 100%;
  padding: 0px 16px;
  // @include set_theme_color(background-color, menu-tab-bg-color);
  // background-color: rgba(0, 36, 64, 0.85);
  background-image: linear-gradient(to top, rgb(0, 36, 64) 0%, #0a385e 50%, #0d4d8d 100%);
  // background-color: #0a3252;
  // background-color: #113860;
  backdrop-filter: blur(4px);
  .tab-list-left {
    flex: 1;
    overflow: hidden;
    height: 50px;
    margin-right: 20px;
    .list-area {
      width: auto;
      height: 50px;
      display: flex;
      align-items: center;
    }
    .hoverStyle {
      // flex: 1;
      // width: 0;
      // max-width: 93px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .tab-item {
      cursor: pointer;
      height: 28px;
      line-height: 28px;
      margin-left: 6px;
      border: none;
      border-radius: 1px 1px 1px 1px;
      // @include set_theme_color(color, page-tab-item-bg-color);
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        .el-icon-close {
          color: #fff;
        }
        color: #fff;
        // @include set_theme_color(color,font-active-color);
        @include set_theme_color(background-color, main-theme-color);
      }
      &.active {
        color: #fff;
        @include set_theme_color(background-color, main-theme-color);
        .el-icon-close {
          color: #fff;
        }
        &::after {
          content: " ";
          display: block;
          width: 0;
          height: 0;
          border-width: 5px 5px 0;
          border-style: solid;
          border-color: transparent transparent transparent;
          @include set_theme_color(border-top-color, font-active-color);
          position: relative;
          margin: 0px auto;
        }
      }
    }
  }
  .opt-right {
    i {
      // @include set_theme_color(color, font-active-color);
      color: #ffffff;
      font-size: 18px;
      margin-right: 20px;
      &:hover {
        // @include set_theme_color(color, font-active-color);
        color: #909399;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
 <style>
.app-menu-tabs .el-tag {
  background-color: rgba(232, 232, 232, 1);
}
</style>